import React from 'react'
import { Field } from 'formik'
import _minBy from 'lodash/minBy'
import { string } from 'yup'

import Dollars from '../../Dollars/Dollars'
import Fieldset from '../../Modifiers/Fieldset/Fieldset'
import Radio from '../../Form/Radio/Radio'
import Input from '../../Form/Input/Input'

import { useGetCart } from '../../CartQuery/CartQuery'
import { isDaasCart } from '../../../utils/cart-helpers'

import './Tip.css'

export const Component = () => {
  const { cart } = useGetCart()
  const { preComputedTips } = cart
  const fieldsetLabel = isDaasCart(cart) ? 'Driver Tip' : 'Tip'
  return (
    <Fieldset label={fieldsetLabel} collapsable id='tip_fields'>
      <div data-testid='label-tip' styleName='tips'>
        {preComputedTips &&
          preComputedTips.map((tip, index) => (
            <Field
              component={Radio}
              style='chunky'
              label={
                <React.Fragment>
                  <span styleName='percent'>{tip.percent}%</span>
                  <span styleName='dollars'>
                    <Dollars amount={tip.value} />
                  </span>
                </React.Fragment>
              }
              data-testid={'percent-tip-' + tip.percent}
              name='creditCardTip'
              id={`tip_${index}`}
              key={`tip_${index}`}
              percent={tip.percent}
              value={tip.value.toFixed(2)}
            />
          ))}
        <Field
          data-testid='custom-tip'
          component={Input}
          label='Custom Amount'
          type='text'
          name='creditCardTip'
          inputMode='decimal'
          id='credit_card_tip'
          key='credit_card_tip'
        />
      </div>
    </Fieldset>
  )
}

export const getInitialValues = ({
  cart,
  featureFlags
}) => {
  const { preComputedTips } = cart
  if (!featureFlags['oo-v3-include-default-tip'] && !isDaasCart(cart)) {
    return { creditCardTip: '' }
  }

  let defaultTip
  if (isDaasCart(cart)) {
    const { value } = preComputedTips.find(({ percent }) => percent === 20) || {}
    defaultTip = value
  } else {
    // OO only
    const { value } = _minBy(preComputedTips, ({ percent }) => percent) || {}
    defaultTip = value
  }

  return {
    creditCardTip: defaultTip ? defaultTip.toFixed(2) : ''
  }
}

export const getValidationSchema = () => {
  return {
    creditCardTip: string().when('paymentType', {
      is: paymentType => {
        const creditPaymentTypes = ['SAVED_CREDIT_CARD', 'CREDIT_CARD']
        return creditPaymentTypes.includes(paymentType)
      },
      then: string()
        .trim()
        .default('')
        // TODO more robust currency validation
        .matches(/^([1-9][0-9]*|0)?(\.\d{2})?$/, 'must be a dollar amount'),
      otherwise: string().default('')
    })
  }
}

export const getArgsForSubmit = ({
  values,
  cart
}) => {
  const { creditCardConfig } = cart.restaurant
  const tipAmount = (creditCardConfig.tipEnabled && parseFloat(values.creditCardTip)) || 0
  return { tipAmount }
}
